// Hover and focus explanations, and the glossary: every technical term gets a plain-English explanation.
import { el, esc } from './util.js';
import { EN } from './content.js';

export var gtip = null, GLRX = null;
export function createTooltip(root) { gtip = el('div', 'wf-gtip'); gtip.hidden = true; gtip.setAttribute('role', 'tooltip'); root.appendChild(gtip); }
export function buildGlossary() {
  GLRX = new RegExp('(^|[^A-Za-z0-9§])(' + Object.keys(EN.glossary).sort(function (a, b) { return b.length - a.length; }).map(function (k) { return k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')(?![A-Za-z0-9])', 'g');
}
export function showGTip(t, x, y) {
  if (!gtip) return; var h = t.getAttribute('data-tip'); if (!h) return;
  gtip.innerHTML = h; gtip.hidden = false;
  var r = gtip.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
  if (x == null) { var b = t.getBoundingClientRect(); x = b.left + b.width / 2; y = b.bottom; }
  var lx = Math.min(vw - r.width - 8, Math.max(8, x + 14)), ly = y + 18; if (ly + r.height > vh - 8) ly = Math.max(8, y - r.height - 12);
  gtip.style.left = lx + 'px'; gtip.style.top = ly + 'px';
}
export function hideGTip() { if (gtip) gtip.hidden = true; }
export function decorate(node) {
  var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
    var p = n.parentNode; if (!p || !n.nodeValue || !/[A-Za-z0-9]/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
    if (p.closest && p.closest('.wf-ab,svg,select,option,script,style,.wf-gtip,textarea,input,button,[data-noab],.wf-map,canvas')) return NodeFilter.FILTER_REJECT;
    GLRX.lastIndex = 0; return GLRX.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; } });
  var list = []; while (walker.nextNode()) list.push(walker.currentNode);
  list.forEach(function (n) {
    var txt = n.nodeValue, frag = document.createDocumentFragment(), last = 0, m; GLRX.lastIndex = 0;
    while ((m = GLRX.exec(txt))) {
      var start = m.index + m[1].length, term = m[2];
      if (start > last) frag.appendChild(document.createTextNode(txt.slice(last, start)));
      var ab = document.createElement('abbr'); ab.className = 'wf-ab'; ab.textContent = term; ab.setAttribute('data-tip', '<b>' + esc(term) + '</b>' + esc(EN.glossary[term])); ab.tabIndex = 0;
      frag.appendChild(ab); last = start + term.length;
    }
    if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
    n.parentNode.replaceChild(frag, n);
  });
}
